import { Clerk, User } from '@clerk/clerk-sdk-node';
import { Injectable } from '@nestjs/common';
import config from 'config';

import { ClerkCreateUser, ClerkUpdateUser } from '../types';

@Injectable()
export class ClerkService {
  // @ts-ignore
  private readonly clerk = new Clerk({ secretKey: config.get('clerk.secretKey') });

  public async createUser(user: ClerkCreateUser): Promise<User> {
    const parameters = { ...user, emailAddress: [user.emailAddress], phoneNumber: user.phoneNumber ? [user.phoneNumber] : undefined };
    return await this.clerk.users.createUser(parameters);
  }

  public async deleteUser(userId: string): Promise<User> {
    return await this.clerk.users.deleteUser(userId);
  }

  public async updateUser({ firstName, lastName, userId }: ClerkUpdateUser): Promise<User> {
    return await this.clerk.users.updateUser(userId, { firstName, lastName });
  }
}
